export const TPA_EXPERIMENTS = {
  INSTALL_ECOM: 'specs.membership.InstallEcom',
  BREAKPOINT_INDICATORS_OOI: 'specs.membership.breakpointIndicatorsOOI',
  ECOM_GEOIP_ADDRESS: 'specs.membership.EcomGeoIpAddress',
  SETTINGS_EVENTS_FIX: 'specs.membership.SettingsEventsFix',
  BUTTON_HOVER_SETTINGS_EDITOR: 'specs.membership.ButtonHoverSettingsEditor',
  BUTTON_HOVER_SETTINGS_VIEWER: 'specs.membership.ButtonHoverSettingsViewer',
  CHECKOUT_TRIGGER_ON_LOGIN_ONCE: 'specs.membership.CheckoutTriggerOnLoginOnce',
  SUGGEST_ECOM_MIGRATION: 'specs.pricingPlans.SuggestEcomMigration',
  IMPROVE_ECOM_LOADING_STATE: 'specs.PricingPlans.ImproveEcomLoadingState',
  START_DATE_FUNCTIONS: 'specs.membership.ShowStartDateFunctionTPA',
  SHOW_PAYWALL_SETTINGS: 'specs.pricing_plans.show_paywall_settings',
  ECOM_TYP_SAFE_ERROR_HANDLING: 'specs.pricingPlans.EcomTypSafeErrorHandling',
  CASHIER_COUPON_DISCOUNT: 'specs.pricingPlans.CashierCouponDiscount',
  PLAN_V3_MIGRATION: 'specs.pricingPlans.PlanV3Migration',
  FONT_SIZE_FOR_TPA_ELEMENTS: 'specs.membership.FontSizeForTPAElements',
  ALLOW_CHECKOUT_IN_EDITOR_PREVIEW: 'specs.pricingPlans.AllowCheckoutInEditorPreview',
  ENABLE_VARIANTS: 'specs.pricingPlans.enableVariants',
  ENABLE_ROUTER_URI_CONFLICT_MESSAGE: 'pricingPlansEnableRouterUriConflictMessage'
};
//# sourceMappingURL=tpa.js.map